import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from "react-icons/md";
import { getAllProducts } from "../apis/config";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./UI/ProductSkeleton";

const TrendProducts = () => {
  const [startIndex, setStartIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(getDisplayCount());
  const [products, setProducts] = useState([]);
  const [loading,setLoading] = useState(true)

  // Get products once
  useEffect(() => {
    getAllProducts()
      .then((res) => {
        setProducts(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  // Filter products marked as "trend"
  const filterProducts = products
    .slice() // copy before reversing to avoid mutating original
    .reverse()
    .filter((pro) =>
      pro.label?.some((label) => label?.toLowerCase() === "trend")
    );

  // Helper: determines how many items to show per screen size
  function getDisplayCount() {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 640) return 2; // Mobile
      if (window.innerWidth < 1024) return 3; // Tablet
    }
    return 4; // Desktop
  }

  // Handle resizing and adjust item count + start index accordingly
  useEffect(() => {
    const handleResize = () => {
      const count = getDisplayCount();
      setItemsPerPage(count);
      setStartIndex((prevIndex) =>
        Math.min(prevIndex, Math.max(0, filterProducts.length - count))
      );
    };

    handleResize(); // run initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [filterProducts]);

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - itemsPerPage, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) =>
      Math.min(prev + itemsPerPage, filterProducts.length - itemsPerPage)
    );
  };

  const visibleProducts = filterProducts.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="w-full p-5 md:px-10">
      <div className="text-center">
        <h3 className="text-[25px] font-bold">Trend Arrivals</h3>
      </div>

      <div className="flex gap-3 py-10 w-full relative overflow-hidden">
        
        {loading
          ? Array(itemsPerPage)
              .fill(0)
              .map((_, idx) => <ProductSkeleton key={idx} />)
          : visibleProducts.map((data, index) => <ProductCard key={index} data={data} />)}

        {/* Previous Button */}
        {startIndex > 0 && (
          <button
            onClick={handlePrev}
            className="absolute left-0 top-1/2 z-20 bg-black text-white p-1 py-3 hover:bg-red-600"
          >
            <MdOutlineArrowBackIos />
          </button>
        )}

        {/* Next Button */}
        {startIndex + itemsPerPage < filterProducts.length && (
          <button
            onClick={handleNext}
            className="absolute right-0 top-1/2 z-20 bg-black text-white p-1 py-3 hover:bg-red-600"
          >
            <MdOutlineArrowForwardIos />
          </button>
        )}
      </div>
    </div>
  );
};

export default TrendProducts;
